
function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

const init = () => {
    const elem = document.querySelector('.block-application-list');
    const imgsContainer = document.querySelector('.block-application-list-img-container');
    const elems = document.querySelectorAll('.block-application-list nav a');
    const elemsImg = document.querySelectorAll('.block-application-list .block-application-list-img');

    if(elem === null || isTouchDevice() === true) return;
    
    elems.forEach((elem, index) => {

        let elCount = index;

        elem.addEventListener('mouseenter', () => {
            elemsImg[elCount].classList.add('active');
        });

        elem.addEventListener('mouseleave', () => {
            elemsImg[elCount].classList.remove('active');
        });
    });

    let wW = window.innerWidth;
    let wH = window.innerWidth;

    elem.addEventListener('mousemove', (e) => {
        
        let x = (e.screenX/wW) * 100;
        let y = ((e.screenY/wH) * 100)/2;

        imgsContainer.style.transform = `translate(${x}%, ${y}%)`;
    });
};

export default { init };